<app-topbar></app-topbar>
<app-create-admin></app-create-admin>
<div class="container mr-top-56 ">
    <h1 class="mainhdng mr-bttm-30">Products & Subscriptions</h1>
    <!-- <a href="" class="gobck"><img src="assets/images/gobck.png"> Go Back</a> -->
    <!-- Payment Detail -->
        <div class="common row mr-top-68 respmartopzero frMbl" *ngIf = "licenseCount">
            <div class="col-md-12 manage_stores">
                <h3 class="pyhdng">Assign your Licenses</h3>
                <p class="boxpara_bold">You selected {{licenseCount}} {{licenseCount > 1 ? 'licenses' : 'license'}}.</p>

                <!-- Mange Licenses -->
                <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
                <div class="licenses_div" formArrayName="addDynamicElement">	
                    <div class="paymenthdng_div paymenthdng_divstore">
                        <h1 class="paymenthdng">Licenses</h1>
                    </div>
                    
                    <div class="row add_stores">
                        <!-- First Box -->
                        <div class="col-md-12 mr-bttm-30" *ngFor="let products of PurchasedProducts; let j = index " [formGroupName]="j" >
                            <input type="text" formControlName="SubscriptionId" hidden>
                            <input type="text" formControlName="company_id" value="{{companyId}}" hidden>
                            <div class="storebox" >
                                <div class="storehdng">
                                    <p class="storehdng_txt">{{products.name}}</p>
                                </div>
                                <div class="row">
                            <div class="col-md-6" >
                                <div class="storecntnt" >
                                        <div class="form-group" >						  
                                            <select formControlName="store_id" class="ordrslct wd-70 newslct form-control"
											(change)="SelectedStore($event.target.value,products.product_id,j)" [(ngModel)]="selectedStores[j] ? selectedStores[j] : emptyStoreArray[j]">
												<option value="" selected>Select Store</option>
												<option *ngFor="let store of Stores" [value]="store.id">
													{{store.store_name}}</option>
                                            </select>
                                            <span class="inputValidation" style="padding-top: 10px;">{{Storemessage[j]}}</span>
                                        </div>
                                        <div class="add_new_store" data-toggle="modal" data-target="#updateStore" (click) ="addStore()">
                                            <img src="assets/images/addstore.png" class="pd-rt-10"> <span class="rmbrme" > Add store</span>
                                        </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="storecntnt">
                                        <div class="form-group">						  
                                            <select formControlName="admin_id" class="ordrslct wd-70 newslct form-control" (change)="checkFormValid($event.target.value,products.product_id,j)" [(ngModel)]="selectedAdmins[j] ? selectedAdmins[j] : emptyAdminArray[j]" >
                                            <option value="">Select Admin User</option>
                                            <option *ngFor="let user of AdminData" [value]="user.admin_user_id">
                                                {{user.first_name}} {{user.last_name}}
                                            </option>

                                        </select>
                                        <span class="inputValidation" style="padding-top: 10px;">{{Adminmessage[j]}}</span>
                                        </div>
                                        <div class="add_new_store"  data-toggle="modal" data-target="#adminUser" (click) ="addAdmin()">
                                            <img src="assets/images/addstore.png" class="pd-rt-10"> <span class="rmbrme"> Add Admin User</span>
                                        </div>
                                </div>
                            </div>
                        </div>
                            </div>									
                        </div>
                        <!-- First Box -->
                    </div>
                    
                </div>
                <!-- Mange Licenses -->

                <div class="common cnclsavebttns">
                    <button type="submit" class="savebttn">Save</button>
                    <!-- <button class="cancelbttn">Cancel</button> -->
                </div>
            </form>
            </div>

        </div>
    

</div>

 <!-- Add Store Modal -->
<!-- Add Store Modal -->
<div class="modal centerModalNew fade in" id="updateStore">
    <div class="modal-dialog ">
    <div class="modal-content">    
    
    
    <!-- Modal body -->
    <div class="modal-body changeimagebody">
        <div class="common billingform ">
            <div class="changeimagediv text-center mr-top-60">
                
                <form [formGroup]="store_update" (ngSubmit)="store_submit($event)">
                    <h6 class="sucssheading clrgry text-left">Add Store</h6>
                    <div class="row">
                    <div class="formrow col-md-4">
                                    <span class="upldimg">
                                        <p class="imgfrme">
                                           <span>
                                           <img [src]="Storeimage"
                           [hidden]="!Storeimage"  />
                                           </span>
                                        </p>
                                     </span>
                                     <img src="assets/images/uploadlogo.png"/>
                                      <label for="files" class="uploadlogoclass">Upload Logo</label>
                                      <input name = "Storeimage" (change)="selectImageStore($event)" accept="image/x-png,image/gif,image/jpeg" id="files" style="visibility:hidden;" type="file">
                                
                                </div>
                                
                                <div class="formrow col-md-8">
                                    <p class="brandtext text-left">Please, select the color of your  store branding,<br/> it will be for custom some emails.</p>
                                
                                <div class="formrow formrowcolorsec">
                                     <div class="text-left mbottomscolor cprimaryseccolor">
                                        <div class="primary_div">
                                            <img src="assets/images/coloricon.png"/><span class="selectcolor">Select a HEX Color</span><input class="cstm_color_picker" id="cstm_color_picker" formControlName="primary_color"
                                            id="cstm_color_new"  
                                            [cpOKButton]="true"
                                            [cpSaveClickOutside]="false"
                                            [cpOKButtonClass]= "'btn btn-primary btn-xs'"
                                            [(colorPicker)]="primary_color" autocomplete="off" readonly
                                            (colorPickerSelect)="handleChangeComplete($event)"/>
                                        </div>
                                        <div *ngIf="storeSubmitted && store_form.primary_color.invalid">
                                            <span class="inputValidation" *ngIf="store_form.primary_color.errors.required">HEX Color is required.</span>
                                    </div>
                                    
                            </div>
                                </div>
                                </div>
                            </div>
                    <div class="row">
                        <div class="form-group col-md-6">
                            <input formControlName="store_name" id="store_name" type="text"  class="form-control" placeholder="Store name">
                            <div *ngIf="storeSubmitted && store_form.store_name.invalid">
                                <span class="inputValidation" *ngIf="store_form.store_name.errors.required">Store name is required.</span>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <input formControlName="owner_name"  id="owner_name" type="text"  class="form-control" placeholder="Owner name">
                            <div *ngIf="storeSubmitted && store_form.owner_name.invalid">
                                <span class="inputValidation" *ngIf="store_form.owner_name.errors.required">Owner name is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-6">
                            <input formControlName="contact_number" id="contact_number" type="text"  class="form-control" placeholder="Contact number" maxlength="15" minlength="10" mask='(000) 000-0000'>
                            <div *ngIf="storeSubmitted && store_form.contact_number.invalid">
                                <span class="inputValidation" *ngIf="store_form.contact_number.errors.required">Contact number. is required.</span>
                                <span class="inputValidation" *ngIf="store_form.contact_number.errors.minlength">Contact number is not valid.</span>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <input formControlName="email_Address"  id="email_Address" type="text"  class="form-control" placeholder="Email Address">
                            <div *ngIf="storeSubmitted && store_form.email_Address.invalid">
                                <span class="inputValidation" *ngIf="store_form.email_Address.errors.required">Email Address is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <input formControlName="address_line1" id="address_line1" type="text"  class="form-control" placeholder="Address Line 1">
                            <div *ngIf="storeSubmitted && store_form.address_line1.invalid">
                                <span class="inputValidation" *ngIf="store_form.address_line1.errors.required">Address Line 1 is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <input formControlName="address_line2" id="address_line2" type="text"  class="form-control" placeholder="Address Line 2">
                        </div>
                    </div>
                     <div class="row">
                        <div class="form-group col-md-6">
                            <select formControlName="country" (change)="changeStateStore($event.target.value)" name="storecountry" class="form-control" >
                                <option value="">Select Country</option>
                                    <option *ngFor="let country of countries" [value]="country.id">
                                    {{country.name}}</option>
                                </select>
                                <div *ngIf="storeSubmitted && store_form.country.invalid">
                                    <span class="inputValidation" *ngIf="store_form.country.errors.required">Country is required.</span>
                                </div>
                            
                        </div>
                        <div class="form-group col-md-6">
                            <div *ngIf="stateLoading else selectStateStore">
                                <img src="assets/images/loading.gif" class="loading_gif"/>
                            </div>   
                            <ng-template #selectStateStore>
                                <select formControlName="State" class="pymntmthds form-control" id="State" autocomplete="off" >
                                    <option value="">Select State</option>
                                    <option *ngFor="let state_store of States" [value]="state_store.id">
                                    {{state_store.name}}
                                    </option>
                                </select>
                            </ng-template>
                            <div *ngIf="storeSubmitted && store_form.State.invalid">
                                <span class="inputValidation" *ngIf="store_form.State.errors.required">State is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-4">
                            <input formControlName="city"  id="city" type="text"  class="form-control" placeholder="City">
                            <div *ngIf="storeSubmitted && store_form.city.invalid">
                                <span class="inputValidation" *ngIf="store_form.city.errors.required">City is required.</span>
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <input formControlName="zip" id="zip" type="text"  class="form-control" placeholder="Zip Code">
                            <div *ngIf="storeSubmitted && store_form.zip.invalid">
                                <span class="inputValidation" *ngIf="store_form.zip.errors.required">Zip Code is required.</span>
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <select formControlName="timezone" name="timezone" class="form-control">
                                <option value="">Select Timezone</option>
                                <option *ngFor="let timezone of timezones" [value]="timezone.name">
                                    {{timezone.gmt}}</option>
                            </select>
                            <div *ngIf="storeSubmitted && store_form.timezone.invalid">
                                <span class="inputValidation" *ngIf="store_form.timezone.errors.required">Timezone is required.</span>
                            </div>
                        </div>
                    </div>
    
                    <div class="common changenumberbttn text-left">
                        <button class="savebttn">Add</button>
                        <button class="cancelbttn close_store_modal" data-dismiss="modal">Close</button>
                      </div>
                      <div class="common text-success sccsmsgdiv" >{{store_added}}</div>
                </form>
    
            </div>
        </div>
    
    </div>
    
    
    
    </div>
    </div>
    </div>